import React, { HTMLProps } from "react";
import { RiErrorWarningLine } from "react-icons/ri";
import "./styles.scss";

interface StoresListSelectProps extends HTMLProps<HTMLInputElement> {
  error: string;
}

function StoresListSelect({ label, error, ...rest }: StoresListSelectProps) {
  const storesList = [
    "Adidas",
    "Amazon",
    "Arezzo",
    "Asics",
    "Atrio Esportes",
    "Avon",
    "Beleza na Web",
    "Bemol",
    "Boleiros",
    "Boticário",
    "Brastemp",
    "Britânia",
    "C&A",
    "Cadence",
    "Camicado",
    "Carrefour",
    "Casa & Video",
    "Casas Bahia",
    "Centauro",
    "Cobasi",
    "ComSchool",
    "Compra Certa",
    "Consul",
    "Dafiti",
    "Decathlon",
    "Dell",
    "Drogaria São Paulo",
    "Drogarias Pacheco",
    "Drogasil",
    "Drograria Catarinense",
    "Electrolux",
    "Estrela",
    "Etna",
    "Extra",
    "Fastshop",
    "Fila",
    "Flexform",
    "Fut Fanatics",
    "Kanui",
    "Kappa",
    "Leroy Merlin",
    "Livraria Cultura",
    "Livraria Saraiva",
    "Lojas Lebes",
    "Madeira Madeira",
    "Magalu",
    "Marisa",
    "Mobly",
    "Mundo verde",
    "Netshoes",
    "Natura",
    "Nike",
    "Ortobom",
    "Óticas Diniz",
    "Padovani",
    "Pet Love",
    "Petz",
    "Polishop",
    "Ponto",
    "Ray Ban",
    "Riachuelo",
    "Ricardo Eletro",
    "Rihappy",
    "Sephora",
    "Shein",
    "Suvinil",
    "Telha Norte",
    "Tramontina",
    "Ultrafarma",
    "Under Armour",
    "Única Ar Condicionado",
    "West Wing",
    "Wine",
    "World Tennis",
    "Zattini",
    "Zelo",
  ];

  return (
    <div className={`containerStoresListSelect ${error ? "error" : ""}`}>
      {label}
      <input list="storesList" {...rest} />
      <datalist id="storesList">
        {storesList.map((option) => (
          <option value={option} key={option}>
            {option}
          </option>
        ))}
      </datalist>
      {error && (
        <div className="errorMessage">
          <RiErrorWarningLine size={24} />
          <span>{error}</span>
        </div>
      )}
    </div>
  );
}

export { StoresListSelect };
